// Spinner — CSS-only loading indicator. No animation libs; the spin
// keyframe is Tailwind's built-in `animate-spin`.
export function Spinner({ className = '' }: { className?: string }) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={`h-6 w-6 animate-spin rounded-full border-2 border-line-strong border-t-glow-600 ${className}`}
    />
  )
}
